import React from 'react';
import { AntTableCell, AntTableCellFilter } from '../../../../../../theme/Table';
import {
  Table,
  TableBody,
  TableHead,
  TableRow,
  Select,
  FormControl, InputLabel,
} from '@mui/material';
import TableFilter from '../../../../../../components/global/table/TableFilter';
import dateFormat from 'dateformat';
import TableSort from '../../../../../../components/global/table/TableSort';
import TableNoDataComponent from '../../../../../../components/global/table/TableNoData';

const TableDnsZones = ({
  data,
  setFilter,
  filter,
  sortActive,
  setSortActive,
  partnerClientAccountId,
  isDelegated,
  setIsDelegated,
  zoneType,
  setZoneType,
}) => {
  return (
    <>
      <Table>
        <TableHead>
          <TableRow>
            <AntTableCell>
              <TableSort
                name="sortId"
                direction={filter?.sort?.sortId}
                label="ID"
                setFilter={setFilter}
                sortActive={sortActive}
                setSortActive={setSortActive}
                filter={filter}
                type={'FILTER_ACTIVE'}
              />
            </AntTableCell>
            <AntTableCell>Zone name</AntTableCell>
            <AntTableCell>Delegated</AntTableCell>
            <AntTableCell>Zone type</AntTableCell>
            <AntTableCell>IP address group ID</AntTableCell>
            <AntTableCell>ACL ID</AntTableCell>
            <AntTableCell>Updated at</AntTableCell>
            <AntTableCell>Created at</AntTableCell>
            <AntTableCell>Status</AntTableCell>

          </TableRow>
          <TableRow>
            <AntTableCellFilter>
              <TableFilter
                name="id"
                setFilter={setFilter}
                filter={filter}
                type={'FILTER_ACTIVE'}
              />
            </AntTableCellFilter>
            <AntTableCellFilter>
              <TableFilter
                name="zone"
                setFilter={setFilter}
                filter={filter}
                type={'FILTER_ACTIVE'}
              />
            </AntTableCellFilter>
            <AntTableCellFilter>
              <FormControl
                variant="outlined"
                size="small"
                style={{ padding: 0, maxWidth: 150 }}
              >
                <InputLabel style={{ height: '25px', lineHeight: '4px', fontSize: 12 }} htmlFor="zone-select">Select</InputLabel>
                <Select
                  native
                  value={isDelegated || ''}
                  style={{ height: '28px' }}
                  inputProps={{
                    name: 'zone-select',
                    id: 'uncontrolled-native',
                  }}
                  displayEmpty
                  onChange={(event) => setIsDelegated(event.target.value === 'all' ? null : event.target.value)}
                >
                  <option value="all">all</option>
                  <option value={'true'}>yes</option>
                  <option value={'false'}>no</option>
                </Select>
              </FormControl>
            </AntTableCellFilter>
            <AntTableCellFilter>
              <FormControl
                  variant="outlined"
                  size="small"
                  style={{ padding: 0, maxWidth: 250 }}
              >
                <InputLabel
                    style={{ height: '25px', lineHeight: '4px', fontSize: 12 }}
                    htmlFor="zone-type-select">
                  Select
                </InputLabel>
                <Select
                  native
                  defaultValue={zoneType}
                  style={{ height: '28px' }}
                  displayEmpty
                  inputProps={{
                    placeholder: 'Select',
                    name: 'zone-type-select',
                    id: 'uncontrolled-native',
                  }}
                  onChange={(event) => setZoneType(event.target.value === 'all' ? null : event.target.value)}
                >
                  <option value="all">all</option>
                  <option value={'primary'}>primary</option>
                  <option value={'secondary'}>secondary</option>
                </Select>
              </FormControl>
            </AntTableCellFilter>
            <AntTableCellFilter>
            </AntTableCellFilter>
            <AntTableCellFilter />
            <AntTableCellFilter />
            <AntTableCellFilter />
            <AntTableCellFilter />
            <AntTableCellFilter />
          </TableRow>
        </TableHead>
        <TableBody>
          {data && data?.dnsResources?.items?.length !== 0 ? (
            data?.dnsResources?.items?.map(
              ({
                id,
                zone,
                delegated,
                remoteId,
                aclId,
                updatedAt,
                createdAt,
                deletedAt,
              }) => (
                <TableRow hover key={id}>
                  <AntTableCell component="th" scope="row">
                    {id}
                  </AntTableCell>
                  <AntTableCell>{zone}</AntTableCell>
                  <AntTableCell>{delegated ? 'yes' : 'no'}</AntTableCell>
                  <AntTableCell>{remoteId ? 'primary' : 'secondary'}</AntTableCell>
                  <AntTableCell>{remoteId}</AntTableCell>
                  <AntTableCell>{aclId}</AntTableCell>
                  <AntTableCell>{dateFormat(updatedAt, 'dd/mm/yy hh:MM:ssTT')}</AntTableCell>
                  <AntTableCell>{dateFormat(createdAt, 'dd/mm/yy hh:MM:ssTT')}</AntTableCell>
                  <AntTableCell>{deletedAt ? 'deleted' : 'active'}</AntTableCell>
                </TableRow>
              )
            )
          ) : (
            <TableNoDataComponent colSpan={9} />
          )}
        </TableBody>
      </Table>
    </>
  );
};
export default TableDnsZones;
